var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.333 3.36719C11.1497 3.36719 3.69971 10.8172 3.69971 20.0005C3.69971 29.1839 11.1497 36.6339 20.333 36.6339C29.5164 36.6339 36.9664 29.1839 36.9664 20.0005C36.9664 10.8172 29.5164 3.36719 20.333 3.36719ZM19.4664 29.8005V22.9005H15.033C14.4164 22.9005 13.9997 22.2339 14.2997 21.6839L20.433 9.73385C20.8164 8.95052 21.9997 9.23385 21.9997 10.1172V17.1005H26.233C26.8497 17.1005 27.2497 17.7505 26.983 18.3005L21.0497 30.1672C20.6497 30.9672 19.4664 30.6839 19.4664 29.8005Z",
    fill: "#00BA07"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/premium.13b45bb23c75dc2c07c271ed3b11acc9.svg";
export { ForwardRef as ReactComponent };